import { LoggerLevel } from 'angular-lib';

export const environment = {
    production: true,
    host: 'tchat.teaser.dating',
    statichost: 'secure.ezstatic.com',
    scheme: 'https',
    tokenName: 'id_token',
    socketIo: {
        endpoint: '/socket.io/dating/chat',
    },
    siteId: 1987175,
    channelId: 8,
    logLevel: LoggerLevel.OFF,
    iovation: {
        snarejs: 'https://mpsnare.iesnare.com/snare.js',
        deniedLink: 'http://free-access.seekeo.com/'
    }
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/environments/environment.prod.ts